import { useRef, useState } from "react";

const SingleFAQ = (props) => {
    const answerRef = useRef(null);

    const [isOpen, setIsOpen] = useState(false);
    const handleIsOpen = () => {
        console.log(answerRef.current);
        setIsOpen(!isOpen);
    }
  return (
    <div className="single-faq">
      <div className="question cursor-pointer inline-block py-2" onClick={handleIsOpen}>
        <h4>{props.question}</h4>
      </div>
      <div ref={(node) => {
        answerRef.current = node;
      }} className={`answer text-[#8b8b8b] text-sm overflow-hidden transition-all duration-200 h-full ${isOpen? 'max-h-[99px]': 'max-h-0'}`}>
        <p>
          {props.children}
        </p>
      </div>
    </div>
  );
};

export default SingleFAQ;
